import {Component, EventEmitter, Input, Output} from '@angular/core';
import {StoryCard} from "../story-card";
import {StoryTheme} from "../story-theme";

@Component({
  selector: 'brt-highlight-card',
  templateUrl: './highlight-card.component.html',
  styleUrls: ['./highlight-card.component.scss']
})
export class HighlightCardComponent {

  @Output('cardTimeout') cardTimeout = new EventEmitter<void>();
  @Input('card-data') set setCardData(val: StoryCard) {
    this.cardData = val;
    this.randomColor = this.getRandomStoryThemeColor();
  };

  @Input('current') set setCurrent(val: boolean) {
    this.current = val;

    if(val) {
      // console.log("opened slide");
    } else {
      // console.log("closed slide");
    }
    if(this.current) {
      if(!this.wasCurrent) {
        // console.log("set timeout ", this.cardData.title);
        setTimeout(() => {
          if(this.current) {
            // console.log("emitting from ", this.cardData.title)
            this.cardTimeout.emit();
          }
        }, 5000);
      }

      this.wasCurrent = true;

    }
  }

  current = false;
  wasCurrent = false;

  randomColor: number = 0;

  cardData!: StoryCard;

  getRandomStoryThemeColor(): number {
    return Math.floor(Math.random() * 8);
  }
}
